import { getFeedbackDetail } from '@/api/feedback'
import FeedbackDialog from '@/components/FeedbackDialog'
export default {
  FeedbackCreate({ commit }, params) {
    var title = '问题反馈与建议'
    var dialog = params.viewController.$dialog({
      template: h => {
        //先写列售前,下一个版本扩展全部工具
        const feedback = {}
        const isModel = false
        const sourceFrom = 'feedback'
        return (
          <sky-feedback-dialog
            feedback={feedback}
            isModel={isModel}
            sourceFrom={sourceFrom}
            onCb={function() {
              dialog.remove()
              params.viewController.fetch()
            }}
          />
        )
      },
      components: {
        FeedbackDialog
      },
      props: {
        title: title,
        width: '45%',
        showClose: false,
        showDefaultFooter: false,
        closeOnPressEscape: false
      }
    })
  },
  FeedbackEdit({ commit }, params) {
    var title = '编辑问题与建议'
    getFeedbackDetail({ id: params.rowId }).then(response => {
      var dialog = params.viewController.$dialog({
        template: h => {
          const feedback = response.data.content
          const isModel = false
          const sourceFrom = 'feedback'
          return (
            <sky-feedback-dialog
              feedback={feedback}
              isModel={isModel}
              sourceFrom={sourceFrom}
              onCb={function() {
                dialog.remove()
                params.viewController.fetch()
              }}
            />
          )
        },
        components: {
          FeedbackDialog
        },
        props: {
          title: title,
          width: '45%',
          showDefaultFooter: false,
          closeOnPressEscape: false
        }
      })
    })
  }
}
